import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Button } from "../components/ui/button";
import { Check, X, UserPlus } from "lucide-react";
import { toast } from "sonner";

function formatDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString("pt-PT", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" });
    } catch { return iso; }
}

export default function AdminClientesPendentesPage() {
    const [pending, setPending] = useState([]);
    const [loading, setLoading] = useState(true);

    async function load() {
        setLoading(true);
        try {
            const r = await api.get("/admin/clientes-pendentes");
            setPending(r.data);
        } catch (e) {
            toast.error("Erro ao carregar");
        } finally { setLoading(false); }
    }
    useEffect(() => { load(); }, []);

    async function approve(u) {
        try {
            await api.put(`/admin/clientes/${u.id}/approve`);
            toast.success(`${u.name} aprovado.`);
            load();
        } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Erro"); }
    }
    async function reject(u) {
        if (!window.confirm(`Rejeitar e eliminar o registo de "${u.name}"?`)) return;
        try {
            await api.delete(`/admin/clientes/${u.id}`);
            toast.success("Registo rejeitado.");
            load();
        } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Erro"); }
    }

    return (
        <>
            <PageHeader
                eyebrow="Administração"
                title="Aprovações de Clientes"
                description="Registos de clientes que aguardam aprovação para poder aceder à app."
                testid="admin-approvals-header"
            />
            {loading ? (
                <div className="flex items-center justify-center py-20"><div className="h-6 w-6 animate-spin rounded-full border-2 border-zinc-300 border-t-[#FF3B30]" /></div>
            ) : pending.length === 0 ? (
                <div className="border border-zinc-200 bg-white p-12 text-center" data-testid="approvals-empty">
                    <UserPlus className="mx-auto mb-3 h-8 w-8 text-zinc-400" />
                    <h3 className="font-['Outfit'] text-lg font-semibold text-zinc-900">Sem registos pendentes.</h3>
                </div>
            ) : (
                <div className="space-y-3" data-testid="approvals-list">
                    {pending.map((u) => (
                        <article key={u.id} className="border border-zinc-200 bg-white p-5" data-testid={`approval-${u.id}`}>
                            <div className="flex items-start justify-between gap-3">
                                <div>
                                    <div className="font-medium text-zinc-900">{u.name}</div>
                                    <div className="text-sm text-zinc-600">{u.email}</div>
                                </div>
                                <div className="flex gap-2">
                                    <Button size="sm" onClick={() => approve(u)} className="rounded-sm bg-green-700 hover:bg-green-800" data-testid={`approve-${u.id}`}>
                                        <Check className="mr-1.5 h-4 w-4" /> Aprovar
                                    </Button>
                                    <Button size="sm" variant="outline" onClick={() => reject(u)} className="rounded-sm text-red-600 hover:text-red-700" data-testid={`reject-${u.id}`}>
                                        <X className="mr-1.5 h-4 w-4" /> Rejeitar
                                    </Button>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </>
    );
}
